import { Program } from 'types/program';
import { network } from 'lib/network';

const apiUrl = process.env.BOND_SPORTS_API_URL;

async function getProgramData(programId: number): Promise<Program> {
	const response = await network.get(`${apiUrl}v1/programs/${programId}`);

	return response.data;
}

export const programApi = { getProgramData };
